import { useMemo } from 'react';
import { useError } from 'react-use';

import { useRestPostQuery } from 'utils/hooks/api/useRestPostQuery';
import {
  ConversionRequest,
  ConversionResponse,
  DEFAULT_QUERY,
} from 'modules/legacySegmentation/domain';

import { retryOnPartialContent } from '../utils';
import { useInsightsResponseHandler } from './useInsightsResponseHandler';

const CONVERSIONS_API = '/lists/insights/conversion';

export const useConversionInsightsQuery = (
  { emailListId, searchQuery, startDate, endDate, page, pageSize, eventName }: ConversionRequest = {
    ...DEFAULT_QUERY,
    eventName: null,
  },
) => {
  const params = useMemo(
    () => ({
      emailListId,
      searchQuery,
      startDate,
      endDate,
      page,
      pageSize,
      eventName,
    }),
    [emailListId, searchQuery, startDate, endDate, page, pageSize, eventName],
  );
  const { handleResponse, data, isRetrying } = useInsightsResponseHandler<ConversionResponse>();
  const { refetch, isLoading, isError, isSuccess } = useRestPostQuery<
    ConversionResponse,
    ConversionRequest
  >(
    CONVERSIONS_API,
    params,
    { retry: retryOnPartialContent, enabled: false, onError: useError() },
    undefined,
    handleResponse,
  );

  return {
    data,
    refetch,
    isLoading: isLoading && !isRetrying,
    isSuccess,
    isError,
  };
};
